/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { MdOutlineClose, MdOutlineUploadFile } from "react-icons/md";

import classnames from "classnames";
import { formatFileSize } from "../../utils/formatFile";
import ErrorMessageComponent from "../Errors/ErrorMessageComponent";

const ImageFileUpload = ({
  title,
  name,
  requiredField,
  acceptedFiles,
  errors,
  handleChange,
  setFieldValue,
  currentLogo,
}) => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [dragError, setDragError] = useState(null);

  const handleFile = (file) => {
    const allowedTypes = ["image/jpeg", "image/png"];
    const fileType = file?.type;
    setDragError(null);
    if (!allowedTypes.includes(fileType)) {
      alert("Invalid file type. Only JPG, and PNG files are allowed.");
    } else if (file.size > 2 * 1024 * 1024) {
      alert("File size exceeds the maximum limit of 2 MB.");
    } else {
      const reader = new FileReader();
      reader.onload = () => {
        setUploadedFile(file);
      };
      reader.readAsDataURL(file);

      // console.log(reader.readAsDataURL(file))
    }
  };
  // When file is uploaded via input
  const handleFileInput = (event) => {
    const file = event.target.files[0];
    handleFile(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  // When file is dropped
  const handleFileDrop = (event) => {
    event.preventDefault();
    setDragOver(false);
    setDragging(false);

    const file = event.dataTransfer.files[0];
    if (file?.size > 0) {
      handleFile(file);
    } else {
      setDragError("Please try again.");
    }
  };

  const handleFileRemove = () => {
    const file = document.getElementById(name);
    file.value = null;
    setUploadedFile(null);
  };

  useEffect(() => {
    if (currentLogo) {
      setUploadedFile(currentLogo);
    }
  }, []);

  return (
    <div className="col-span-full">
      <label
        htmlFor={name}
        className="block leading-6 text-gray-500 mb-3 text-sm cursor-pointer"
      >
        {title} {requiredField && <span className="text-red-800 mx-1">*</span>}
        <div
          className={classnames(
            "mt-2 flex justify-center rounded-lg border border-dashed  px-6 py-2",
            errors[name] ? "border-red-600" : "border-gray-300",
            dragOver && "bg-renu-blue-3/70"
          )}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleFileDrop}
        >
          <div className="text-center">
            <MdOutlineUploadFile
              className="mx-auto h-8 w-8 text-gray-300"
              aria-hidden="true"
            />
            <div className="flex text-sm leading-6 text-gray-600">
              <label
                htmlFor={name}
                className={classnames(
                  "relative cursor-pointer rounded-md bg-transparent font-normal focus-within:outline-none focus-within:ring-0",
                  errors[name]
                    ? "text-red-600 hover:text-red-600"
                    : "text-gray-500 hover:text-gray-500/80"
                )}
              >
                Click here to upload a file
                <input
                  id={name}
                  name={name}
                  type="file"
                  className="sr-only"
                  required={requiredField}
                  onInput={handleFileInput}
                  onChange={(e) => setFieldValue(name, e.target.files[0])}
                />
              </label>
              <p className="pl-1">or drag and drop</p>
            </div>
            {acceptedFiles && (
              <p className="text-xs leading-5 text-gray-500 font-normal">
                {acceptedFiles}
              </p>
            )}
            {dragError && <p className="text-xs text-red-600">{dragError}</p>}
          </div>
        </div>
      </label>
      {uploadedFile && (
        <div className="grid grid-cols-6 mt-2 text-xs bg-gray-100 text-gray-600 font-medium rounded-md items-center py-1 px-4">
          <p className="col-span-3 pr-3 break-words">{uploadedFile.name}</p>
          <p className="col-span-2 text-left">
            {formatFileSize(uploadedFile.size)}
          </p>
          <div className="col-span-1 flex items-center justify-end">
            <button
              onClick={handleFileRemove}
              className="text-xs hover:text-gray-400 active:text-gray-600 sm:text-lg"
            >
              <MdOutlineClose />
            </button>
          </div>
        </div>
      )}

      {errors && <ErrorMessageComponent message={errors[name]?.message} />}
    </div>
  );
};

export default ImageFileUpload;
